// Temporary and to be removed when we make a decision on saved searches using legacy grading
export default {
	description: 'If your saved searches use the old grades, update them to continue getting results',
	title: 'Updated vehicle grading',
};
